import React from "react";

const sizeMap = {
  sm: { box: "w-6 h-6", font: "text-[11px]" },
  md: { box: "w-8 h-8", font: "text-[13px]" },
  lg: { box: "w-10 h-10", font: "text-sm" },
};

const getDisplayName = (creator) => {
  if (!creator) return "";
  const local = creator.local || {};
  const google = creator.google || {};
  const facebook = creator.facebook || {};
  const fullName = [local.firstName, local.lastName].filter(Boolean).join(" ");
  return (
    fullName ||
    local.displayName ||
    google.displayName ||
    facebook.displayName ||
    local.email ||
    google.email ||
    facebook.email ||
    ""
  );
};

const getInitial = (creator, nameFallback) => {
  // First letter of first name, else display
  const local = creator?.local || {};
  const firstName = (nameFallback || local.firstName || "").trim();
  if (firstName) return firstName[0].toUpperCase();
  const name = nameFallback || getDisplayName(creator);
  return name?.trim()?.[0]?.toUpperCase() || "U";
};

const Avatar = ({
  creator,
  size = "md",
  nameFallback = "",
  urlFallback = "",
  className = "",
}) => {
  const sz = sizeMap[size] || sizeMap.md;
  const initial = getInitial(creator, nameFallback);

  return (
    <div
      className={`${sz.box} relative rounded-full bg-accent text-white ring-1 ring-accent/20 ${className}`}
    >
      <span
        aria-hidden
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${sz.font} uppercase leading-none select-none font-display font-semibold`}
      >
        {initial}
      </span>
    </div>
  );
};

export default Avatar;
